import { Scene as m, WebGLRenderer as g, sRGBEncoding as w, PerspectiveCamera as y, Group as p } from "three";
import { CSS3DRenderer as x } from "three/addons/renderers/CSS3DRenderer.js";
import { Controller as A } from "./mindar-pose.prod.js";
import { U as b } from "./ui-DWEIEpuJ.js";
class R {
  constructor({
    container: n,
    uiLoading: i = "yes",
    uiScanning: t = "yes",
    uiError: o = "yes",
    filterMinCF: e = null,
    filterBeta: r = null,
    userDeviceId: a = null,
    environmentDeviceId: s = null,
    disablePoseMirror: v = !1
  }) {
    this.container = n, this.ui = new b({ uiLoading: i, uiScanning: t, uiError: o }), this.controller = new A({
      filterMinCF: e,
      filterBeta: r
    }), this.disablePoseMirror = v, this.scene = new m(), this.cssScene = new m(), this.renderer = new g({ antialias: !0, alpha: !0 }), this.renderer.outputEncoding = w, this.renderer.setPixelRatio(window.devicePixelRatio), this.cssRenderer = new x({ antialias: !0 }), this.camera = new y(), this.userDeviceId = a, this.environmentDeviceId = s, this.anchors = [], this.latestEstimate = null, this.container.appendChild(this.renderer.domElement), this.container.appendChild(this.cssRenderer.domElement), this.shouldFaceUser = !0, window.addEventListener("resize", this._resize.bind(this));
  }
  async start() {
    this.ui.showLoading(), await this._startVideo(), await this._startAR(), this.ui.hideLoading();
  }
  stop() {
    this.video.srcObject.getTracks().forEach((i) => i.stop()), this.video.remove(), this.controller.stopProcessVideo();
  }
  switchCamera() {
    this.shouldFaceUser = !this.shouldFaceUser, this.stop(), this.start();
  }
  addAnchor(n) {
    const i = new p();
    i.matrixAutoUpdate = !1;
    const t = { group: i, landmarkIndex: n, css: !1 };
    return this.anchors.push(t), this.scene.add(i), t;
  }
  // Anchor positioned at the midpoint between two pose landmarks.
  addMidpointAnchor(n, i) {
    const t = new p();
    t.matrixAutoUpdate = !1;
    const o = { group: t, midpointOf: [n, i], css: !1 };
    return this.anchors.push(o), this.scene.add(t), o;
  }
  addCSSAnchor(n) {
    const i = new p();
    i.matrixAutoUpdate = !1;
    const t = { group: i, landmarkIndex: n, css: !0 };
    return this.anchors.push(t), this.cssScene.add(i), t;
  }
  getLatestEstimate() {
    return this.latestEstimate;
  }
  _startVideo() {
    return new Promise((n, i) => {
      if (this.video = document.createElement("video"), this.video.setAttribute("autoplay", ""), this.video.setAttribute("muted", ""), this.video.setAttribute("playsinline", ""), this.video.muted = !0, this.video.style.position = "absolute", this.video.style.top = "0px", this.video.style.left = "0px", this.video.style.zIndex = "-2", this.container.appendChild(this.video), !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.ui.showCompatibility(), i();
        return;
      }
      const t = { audio: !1, video: {} };
      this.shouldFaceUser ? this.userDeviceId ? t.video.deviceId = { exact: this.userDeviceId } : t.video.facingMode = "user" : this.environmentDeviceId ? t.video.deviceId = { exact: this.environmentDeviceId } : t.video.facingMode = "environment", navigator.mediaDevices.getUserMedia(t).then((o) => {
        this.video.addEventListener("loadedmetadata", () => {
          this.video.setAttribute("width", this.video.videoWidth), this.video.setAttribute("height", this.video.videoHeight), this.video.play().catch((e) => {
            console.warn("Pose video play() failed:", e);
          }), n();
        }), this.video.srcObject = o;
      }).catch((o) => {
        console.log("getUserMedia error", o), i();
      });
    });
  }
  _startAR() {
    return new Promise(async (n) => {
      const i = this.video;
      this.controller.onUpdate = ({ hasPose: o, estimateResult: e }) => {
        for (let r = 0; r < this.anchors.length; r++)
          this.anchors[r].css ? this.anchors[r].group.children.forEach((a) => {
            a.element.style.visibility = o ? "visible" : "hidden";
          }) : this.anchors[r].group.visible = o;
        if (o) {
          this.latestEstimate = e;
          for (let r = 0; r < this.anchors.length; r++) {
            const a = this.anchors[r], s = a.midpointOf ? this.controller.getBodyFrameMatrix() : this.controller.getLandmarkMatrix(a.landmarkIndex);
            if (s)
              if (this.anchors[r].css) {
                const h = [
                  1e-3 * s[0],
                  1e-3 * s[1],
                  s[2],
                  s[3],
                  1e-3 * s[4],
                  1e-3 * s[5],
                  s[6],
                  s[7],
                  1e-3 * s[8],
                  1e-3 * s[9],
                  s[10],
                  s[11],
                  1e-3 * s[12],
                  1e-3 * s[13],
                  s[14],
                  s[15]
                ];
                this.anchors[r].group.matrix.set(...h);
              } else
                this.anchors[r].group.matrix.set(...s);
          }
        } else
          this.latestEstimate = null;
      };
      const t = this.shouldFaceUser && !this.disablePoseMirror;
      await this.controller.setup(t), this._resize(), await this.controller.dummyRun(i), this._resize(), this.controller.processVideo(i), n();
    });
  }
  _resize() {
    const { renderer: n, cssRenderer: i, camera: t, container: o, video: e } = this;
    if (!e || !e.videoWidth) return;
    this.video.setAttribute("width", e.videoWidth), this.video.setAttribute("height", e.videoHeight), this.controller.onInputResized(e);
    const { fov: r, aspect: a, near: s, far: v } = this.controller.getCameraParams();
    t.fov = r, t.aspect = a, t.near = s, t.far = v, t.updateProjectionMatrix(), n.setSize(e.videoWidth, e.videoHeight), i.setSize(e.videoWidth, e.videoHeight);
    let h, d;
    const u = e.videoWidth / e.videoHeight, f = o.clientWidth / o.clientHeight;
    u > f ? (d = o.clientHeight, h = d * u) : (h = o.clientWidth, d = h / u), e.style.top = -(d - o.clientHeight) / 2 + "px", e.style.left = -(h - o.clientWidth) / 2 + "px", e.style.width = h + "px", e.style.height = d + "px", this.shouldFaceUser && !this.disablePoseMirror ? e.style.transform = "scaleX(-1)" : e.style.transform = "scaleX(1)";
    const c = n.domElement;
    c.style.position = "absolute", c.style.top = e.style.top, c.style.left = e.style.left, c.style.width = e.style.width, c.style.height = e.style.height;
    const l = i.domElement;
    l.style.position = "absolute", l.style.top = e.style.top, l.style.left = e.style.left, l.style.transformOrigin = "top left", l.style.transform = "scale(" + h / e.videoWidth + "," + d / e.videoHeight + ")";
  }
}
window.MINDAR || (window.MINDAR = {});
window.MINDAR.POSE || (window.MINDAR.POSE = {});
window.MINDAR.POSE.MindARThree = R;
export {
  R as MindARThree
};
